import { useEffect } from 'react';
import { Container, Grid, Typography, Button, InputLabel } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid';
import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE } from 'route/RouteEnums';
import COLORS from 'theme/colors';
import CustomDataGrid from 'utils/customDataGrid';
import { AuthContext } from 'utils/AuthContext';
import { Page } from 'components/Page';
import { getAllRolesAPI,createRoleAPI,updateRoleAPI } from 'services/roleManagementServices';

interface RoleRow {
  id: string;
  name: string;
  roleId: string;
  description: string | null;
  created: string;
}




function ManageRoles() {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const pageKey = 'admin-role-management';
  const [roles, setRoles] = useState<RoleRow[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
  fetchRoles();
}, []);

const fetchRoles = async () => {
  try {
    setLoading(true);

    const response = await getAllRolesAPI();
    const data = response.data;

    const mappedRoles: RoleRow[] = data.map((role: any) => ({
      id: role.id,                // important → DB id
      name: role.name,
      roleId: role.id,
      description: role.description,
      created: role.createdDate,
    }));

    setRoles(mappedRoles);
  } catch (error) {
    console.error('Error fetching roles:', error);
  } finally {
    setLoading(false);
  }
};



  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      width: 250,
      sortable: true,
      filterable: true,
      hideable: false,
    },
    {
      field: 'description',
      headerName: 'Description',
      width: 400,
      sortable: true,
      filterable: true,
      valueGetter: (params: any) => params?.value || 'None',
    },
    {
      field: 'created',
      headerName: 'Created',
      width: 200,
      type: 'dateTime',
      sortable: true,
      filterable: false,
      valueFormatter: (params: any) => {
        if (!params?.value) return '';
        const date = new Date(params.value);
        return date.toLocaleString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        });
      },
    },
  ];

  const handleRowClick = (params: any) => {
    // Redirect to RoleDetail page with role data
    navigate(`${ROUTE.ADMIN_PRACTICE_MANAGE_ROLES_AND_PERMISSIONS}/${params.id}`);
  };

  const handleAddRole = () => {
    // For now, navigate to the same detail page in "create" mode
    // You can use a flag or a separate route like /admin/roles/new
    navigate(`${ROUTE.ADMIN_PRACTICE_MANAGE_ROLES_AND_PERMISSIONS}/new`);
  };

  const canExport = user?.permissions?.includes('EXPORT_DATA');

  return (
    <Page backDir={ROUTE.ADMIN_PRACTICE_MANAGE_USERS_LIST} buttonText='Back'>
      <Container maxWidth='lg'>
        <Grid container alignItems='center' justifyContent='space-between' sx={{ pt: 3, mb: 3 }}>
          <Grid item>
            <Typography variant='h5' sx={{ textTransform: 'capitalize' }}>
              Manage Roles
            </Typography>
          </Grid>
          <Grid item>
            <Button variant='contained' color='primary' onClick={handleAddRole}>
              Add Role
            </Button>
          </Grid>
        </Grid>

        <Grid item xs={12} sx={{ backgroundColor: COLORS.White }}>
          <Grid container sx={{ background: '#FFFBF1', justifyContent: 'space-between' }}>
            {/* Empty header strip to match PatientDatabaseReport.tsx exactly */}
          </Grid>

          <CustomDataGrid
            centered
            rows={roles}
            columns={columns}
            dashBordKey={pageKey}
            onRowSelect={handleRowClick}
            userId={user?.userId || ''}
            loading={loading}
            setting={{
              disableExport: !canExport,
            }}
            getRowId={(row: GridValidRowModel) => row.id}
          />
        </Grid>
      </Container>
    </Page>
  );
}

export default ManageRoles;
